import compact from "lodash/compact";
import map from "lodash/map";
import { useProfileCustomValues } from "PFApp/hooks/use_profile_custom_values";
import { TableColumn } from "PFCore/types";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

const CUSTOM_TYPES = ["match_info_1", "match_info_2", "match_info_3", "match_info_4", "match_info_5"];

export const useProfilesColumns = () => {
  const { t } = useTranslation("profiles", { keyPrefix: "list.table.headers" });
  const { getCustomType } = useProfileCustomValues();

  const defaultColumns: TableColumn[] = useMemo(
    () => [
      {
        name: "name",
        title: t("name"),
        size: 3,
        type: "text",
        isDefault: true,
        locked: true,
        attribute: ["profile"]
      },
      {
        name: "coreSkills",
        title: t("coreSkills"),
        size: 1,
        type: "text"
      },
      {
        name: "otherSkills",
        title: t("otherSkills"),
        size: 1,
        type: "text"
      }
    ],
    [t]
  );

  const customFieldsColumns: TableColumn[] = useMemo(
    () =>
      compact(
        map(CUSTOM_TYPES, (sectionKey, index) => {
          const customType = getCustomType(sectionKey);
          if (!customType) {
            return undefined;
          }
          return {
            name: CUSTOM_TYPES[index] || customType.name || "",
            title: customType.display_as || "",
            order: customType.position,
            kind: customType.kind,
            type: "custom_field",
            attribute: ["profile", customType.name || ""]
          };
        })
      ),
    [getCustomType]
  );

  return { defaultColumns, customFieldsColumns };
};
